module.exports = __webpack_public_path__ + "img/20.457c7a51.jpg";